import { render } from "./BecomeClient.vue?vue&type=template&id=3abfeb9e&scoped=true"
import script from "./BecomeClient.vue?vue&type=script&lang=js"
export * from "./BecomeClient.vue?vue&type=script&lang=js"

import "./BecomeClient.vue?vue&type=style&index=0&id=3abfeb9e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abfeb9e"]])

export default __exports__